export default __webpack_public_path__ + "static/media/18.329dbc3e.jpeg";